import { ILoyaltyProgram } from "../../types/entities/program";

export const inflateGHAConfigurations = (program: ILoyaltyProgram) => {
  program.config.apiVersion = 3;
};
